import script from "./tablePage.vue?vue&type=script&setup=true&lang=js"
export * from "./tablePage.vue?vue&type=script&setup=true&lang=js"

import "./tablePage.vue?vue&type=style&index=0&id=640763b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-640763b0"]])

export default __exports__